import { SWRConfiguration, SWRResponse } from "swr";

import { CachedConfigurationSourceData, GetConfigurationSourceData, GetConfigurationSourceDataResponse } from "@/api/dtos";
import useGet from "@/hooks/api/useGet";
import { useMemo } from "react";

const getData = (response?: SWRResponse<GetConfigurationSourceDataResponse, GetConfigurationSourceDataResponse>) => response?.data?.data;
const getError = (response?: SWRResponse<GetConfigurationSourceDataResponse, GetConfigurationSourceDataResponse>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (response?: SWRResponse<GetConfigurationSourceDataResponse, GetConfigurationSourceDataResponse>) => ({});

export const useConfigurationSourceDataMap = (trialId?: number,configurationSourceDataId?: number, configuration?: SWRConfiguration | undefined) => {
    const request = useMemo(() => {
        if (!configurationSourceDataId || !trialId) {
            return undefined;
        }

        return () => {
            return new CachedConfigurationSourceData({ trialId, configurationSourceDataId });
        }
    }, [configurationSourceDataId, trialId]);

    return useGet(request, { getData, getError, getAdditionalState }, configuration);
}

export default useConfigurationSourceDataMap;